module.exports = __webpack_public_path__ + "img/ok.a7314176.svg";